module.exports = __webpack_public_path__ + "img/galapagos-islands.09b5e684.svg";